export const AvatarSizes = {
    Small: 'sm',
    Medium: 'md',
    Large: 'lg',
    XLarge: 'xl'
} as const;

export type AvatarSize = typeof AvatarSizes[keyof typeof AvatarSizes];
